import React from "react";
import styles from "./styles.module.scss";

const UploadedFile = ({ file, onRemove }) => {
  return (
    <div className={styles.fileItem}>
      {file.name}
      <span className={styles.removeFile} onClick={onRemove}>
        &times;
      </span>
    </div>
  );
};

export default UploadedFile;
